"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workflowHelpersForReduxForm = exports.validationFunctionWrapper = exports.makeValidateFunctionFromRulesFactory = exports.makeValidateFunction = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _index = _interopRequireDefault(require("../../../../common/validation/index"));

// Use this when the validation rules are static.
var makeValidateFunction = function makeValidateFunction(rules) {
  return function (values, props) {
    var finalRules = (0, _isFunction2.default)(rules) ? rules() : rules;

    var validationResults = _index.default.validate(values, finalRules).invalidAttrs;

    var setStepValidationResults = (0, _get2.default)(props, 'workflowStepCallbacks.setStepValidationResults');

    if ((0, _isFunction2.default)(setStepValidationResults)) {
      setStepValidationResults(validationResults);
    }

    return validationResults;
  };
}; // Use this when you want the validation rules to be dynamic, calculated from
// the current props, or even the current field values.


exports.makeValidateFunction = makeValidateFunction;

var makeValidateFunctionFromRulesFactory = function makeValidateFunctionFromRulesFactory(rulesFactory) {
  return function (values, props) {
    var finalRules = rulesFactory({
      values: values,
      props: props
    });

    var validationResults = _index.default.validate(values, finalRules).invalidAttrs;

    var setStepValidationResults = (0, _get2.default)(props, 'workflowStepCallbacks.setStepValidationResults');

    if ((0, _isFunction2.default)(setStepValidationResults)) {
      setStepValidationResults(validationResults);
    }

    return validationResults;
  };
}; // Use this when you have a function that does the validation, accepting a "values" arg


exports.makeValidateFunctionFromRulesFactory = makeValidateFunctionFromRulesFactory;

var validationFunctionWrapper = function validationFunctionWrapper(validationFn) {
  return function (values, props) {
    var validationResults = validationFn(values).invalidAttrs;
    var setStepValidationResults = (0, _get2.default)(props, 'workflowStepCallbacks.setStepValidationResults');

    if ((0, _isFunction2.default)(setStepValidationResults)) {
      setStepValidationResults(validationResults);
    }

    return validationResults;
  };
};

exports.validationFunctionWrapper = validationFunctionWrapper;
var workflowHelpersForReduxForm = {
  makeValidateFunction: makeValidateFunction,
  makeValidateFunctionFromRulesFactory: makeValidateFunctionFromRulesFactory,
  validationFunctionWrapper: validationFunctionWrapper
};
exports.workflowHelpersForReduxForm = workflowHelpersForReduxForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/helpers/validateFactoryForReduxFormAndWorkflow.js
// module id = 4518
// module chunks = 25